const addressTypeEnum = Object.freeze({
    WORK: 5,
    HOME: 10,
    OTHER: 15
});
export default addressTypeEnum;
